import { SortType } from '@gp/enums/common';
import { DEFAULT_SEARCH } from '@gp/constants/const';

// import type { Action, Reducer, Effect } from 'umi';
import type { Action, Reducer } from 'umi';
import type { SortBy } from 'tea-component/lib/table/addons';
import type { IPayload, ISearchPayloadPageStore } from '@gp/types/global';
import type { IPipelineChangeDetailFilterVO, IPipelineChangeDetailTableRecord } from '@gp/types/changeLog';

export interface ILockerData {
  lock: boolean;
  filter: IPipelineChangeDetailFilterVO;
  sort: SortBy<IPipelineChangeDetailTableRecord>[];
  search: ISearchPayloadPageStore;
}

type IUpdateLockerDataAction = Action<'updateLockerData'> & IPayload<any>;
type IClearLockerDataAction = Action<'clearLockerData'> & IPayload<unknown>;

interface ILockerModel {
  namespace: string;
  state: ILockerData;
  reducers: {
    updateLockerData: Reducer<ILockerData, IUpdateLockerDataAction>;
    clearLockerData: Reducer<ILockerData, IClearLockerDataAction>;
  };
  effects: {};
}

export const LOCKER_MODEL_NAMESPACE = 'dbg-model-pipeline-change-log-change-detail-locker';

export const DEFAULT_FILTER: IPipelineChangeDetailFilterVO = {
  rangePicker: {
    dateType: 'date',
    startDate: '',
    endDate: '',
  },
  pteam: [],
  studio: [],
  tab: [],
  update_user: [],
  stage: [],
};

export const DEFAULT_SORT: SortBy<IPipelineChangeDetailTableRecord>[] = [
  { by: 'tab', order: SortType.None as any },
  { by: 'update_time', order: SortType.Desc },
];

export const DEFAULT_LOCKER_DATA: ILockerData = {
  lock: false,
  filter: DEFAULT_FILTER,
  sort: DEFAULT_SORT,
  search: DEFAULT_SEARCH,
};

const LockerModel: ILockerModel = {
  namespace: LOCKER_MODEL_NAMESPACE,
  state: DEFAULT_LOCKER_DATA,
  reducers: {
    updateLockerData(state, action) {
      return { ...state, ...action?.payload, lock: true };
    },
    clearLockerData(state) {
      return { ...state, ...DEFAULT_LOCKER_DATA, lock: false };
    },
  },
  effects: {},
};

export default LockerModel;
